import React from 'react';
import { Link } from 'react-router-dom';
import { ModelListPage } from '/imports/ui/ModelListPage';
import { modelClass, projectStatus } from '/imports/api/projects';
import { formatDateTime } from '/imports/utils';
import { useHasGenerate } from '/imports/hooks';

/** Lists projects in a sortable model table with links to each project. */
export const ProjectsPage = () => {
  const canGenerate = useHasGenerate();
  return <ModelListPage
    permission={() => canGenerate}
    modelClass={modelClass}
    columns={[
      { field: 'name', render: (doc) => <Link style={{width: '20rem;'}} to={`${modelClass.pathPrefix}/${doc._id}${doc.status !== 'new' ? '/view' : ''}`}>{doc.name}</Link>, width: '15rem' },
      { field: 'address', render: (doc) => <span>{doc.address?.formatted}</span>, width: '30rem' },
      { field: 'status', render: (doc) => <span>{projectStatus(doc)}</span> },
      { field: 'updatedAt', render: (doc) => <span>{doc.updatedAt && formatDateTime(doc.updatedAt)}</span> },
      { field: 'createdAt', render: (doc) => <span>{doc.createdAt && formatDateTime(doc.createdAt)}</span> },
    ]}
    defaultSort={{ createdAt: -1 }}
  />;
};